import { withStyles } from '../../tools/withStyles';
import { withAnimation } from '../../tools/withAnimation';
import { withSounds } from '../../tools/withSounds';
import { Component } from './Header';
import { styles } from './Header.styles';

const Header = withAnimation()(withStyles(styles)(withSounds()(Component)));

export { Header };

// Commit trace: 2025-08-28T10:06:35 - feat: add utility helper to index.js
